(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('FeedbackController', FeedbackController);

  FeedbackController.$inject = ['$scope', '$state', 'Feedback', 'FeedbackSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

  function FeedbackController($scope, $state, Feedback, FeedbackSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
    var vm = this;

    vm.loadPage = loadPage;
    vm.predicate = pagingParams.predicate;
    vm.reverse = pagingParams.ascending;
    vm.transition = transition;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.clear = clear;
    vm.search = search;
    vm.loadAll = loadAll;
    vm.searchQuery = pagingParams.search;
    vm.currentSearch = pagingParams.search;

    loadAll();

    function loadPage(page) {
      vm.page = page;
      vm.transition();
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page,
        sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
        search: vm.currentSearch
      });
    }

    function clear() {
      vm.links = null;
      vm.page = 1;
      vm.predicate = 'id';
      vm.reverse = true;
      vm.currentSearch = null;
      vm.transition();
    }

    function loadAll() {
      if (pagingParams.search) {
        FeedbackSearch.query({
          query: pagingParams.search,
          page: pagingParams.page - 1,
          size: vm.itemsPerPage,
          sort: sort()
        }, onSuccess, onError);
      } else {
        Feedback.query(function (result) {
          vm.feedbacks = result;
        });
      }

      function sort() {
        var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        if (vm.predicate !== 'id') {
          result.push('id');
        }
        return result;
      }

      function onSuccess(data, headers) {
        vm.links = ParseLinks.parse(headers('Link'));
        vm.totalItems = headers('X-Total-Count');
        vm.queryCount = vm.totalItems;
        vm.feedbacks = data;
        vm.page = pagingParams.page;
      }

      function onError(error) {
        AlertService.error(error.data.message);
      }
    }

    function search(searchQuery) {
      if (!searchQuery) {
        return vm.clear();
      }
      vm.links = null;
      vm.page = 1;
      vm.predicate = '_score';
      vm.reverse = false;
      vm.currentSearch = searchQuery;
      vm.transition();
    }

    /* function search () {
         if (!vm.searchQuery) {
             return vm.loadAll();
         }
         FeedbackSearch.query({query: vm.searchQuery}, function(result) {
             vm.feedbacks = result;
         });
     }  */
  }
})();
